import { useState } from "react";

const STAGING_HOSTNAME = "staging.d3ook5rszm82xe.amplifyapp.com";

const StagingBanner = () => {
  const [dismissed, setDismissed] = useState(false);

  const isStaging =
    window.location.hostname === STAGING_HOSTNAME ||
    // Dev/test-only hook so the banner can be rendered locally (e.g. Playwright).
    // Stripped from production builds where import.meta.env.DEV is false.
    (import.meta.env.DEV &&
      new URLSearchParams(window.location.search).has("stagingBanner"));

  if (!isStaging || dismissed) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-yellow-500 text-black text-center py-1.5 text-sm font-medium">
      ⚠️ STAGING ENVIRONMENT - Changes here do not affect production
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss staging banner"
        className="absolute right-2 top-1/2 -translate-y-1/2 flex h-6 w-6 items-center justify-center rounded text-lg leading-none text-black/70 transition-colors hover:bg-black/10 hover:text-black"
      >
        ×
      </button>
    </div>
  );
};

export default StagingBanner;
